// extracted by mini-css-extract-plugin
export default {"verified":"ContactVerificationBadge_verified__SCNnM","unverified":"ContactVerificationBadge_unverified__d3Y-B","confirmButton":"ContactVerificationBadge_confirmButton__wDxcG"};